import React from "react";
import SITE from "@/constants/site";
import SITE_IDS from "@/constants/testIds/site";

export default function Footer() {
  return (
    <footer data-testid={SITE_IDS.footer} className="footer">
      <div className="container footer__inner">
        <div className="footer__mark font-script">{SITE.couple}</div>
        <div className="footer__rule" />
        <div className="footer__meta">
          <span className="font-display">{SITE.dateShort}</span>
          <span className="footer__sep">·</span>
          <span>With love, and a little push</span>
        </div>
      </div>
    </footer>
  );
}
